export default Object.freeze({
  biggest: -1,
  registered: 0,
  associated: 1,
  added: 2,
});
